import React, { useRef, useState } from 'react'; // 导入useState
import './HomePage.css'; // 引入新的CSS文件

const PricePage = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true); // 初始状态为静音

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted); // 切换图标状态
    }
  };

  return (
    <main className="snap-container" style={{ background: 'linear-gradient(to bottom right, #1e3a8a, #7e22ce, #000000)' }}>
      {/* 英雄区域 */}
      <section className="snap-section relative h-screen flex items-center justify-center overflow-hidden">
        <div className="container mx-auto px-4 z-10 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            全新小型算力中心
          </h1>
          <p className="text-2xl text-blue-200 mb-8 max-w-3xl mx-auto">
            本地部署AI大模型，畅享高效智能计算，数据安全可控
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-4">
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-300 text-lg">
              了解详情
            </button>
            <button className="bg-transparent border-2 border-blue-400 text-blue-400 hover:bg-blue-400 hover:text-black font-bold py-3 px-8 rounded-lg transition-colors duration-300 text-lg">
              联系咨询
            </button>
          </div>
        </div>
      </section>

      {/* 产品规格 */}
      <section className="snap-section py-20">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-white text-center mb-16">产品规格</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* 硬件规格 */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-blue-400 mb-6">硬件配置</h3>
              <ul className="space-y-4 text-white">
                <li className="flex items-start">
                  <span className="text-green-400 mr-3 text-xl">⚡</span>
                  <div>
                    <span className="font-semibold">处理器：</span>
                    <span>AMD Ryzen AI MAX+395</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-3 text-xl">🎮</span>
                  <div>
                    <span className="font-semibold">显卡：</span>
                    <span>Radeon 8060S Graphics</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-3 text-xl">💾</span>
                  <div>
                    <span className="font-semibold">显存：</span>
                    <span>96G共享显存</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-3 text-xl">📦</span>
                  <div>
                    <span className="font-semibold">存储：</span>
                    <span>SSD 1TB</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-3 text-xl">🔋</span>
                  <div>
                    <span className="font-semibold">功耗：</span>
                    <span>稳定满载功耗120W</span>
                  </div>
                </li>
              </ul>
            </div>
            {/* 软件规格 */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-purple-400 mb-6">软件配置</h3>
              <ul className="space-y-4 text-white">
                <li className="flex items-start">
                  <span className="text-green-400 mr-3 text-xl">🧠</span>
                  <div>
                    <span className="font-semibold">大语言模型：</span>
                    <span>打包安装70B大语言模型</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-3 text-xl">⚡</span>
                  <div>
                    <span className="font-semibold">处理速度：</span>
                    <span>每秒可处理40TOKEN</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-3 text-xl">🦞</span>
                  <div>
                    <span className="font-semibold">智能助手：</span>
                    <span>一键安装锲客龙虾</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-3 text-xl">🤖</span>
                  <div>
                    <span className="font-semibold">自主控制：</span>
                    <span>可自主控制电脑执行任务</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-3 text-xl">🚀</span>
                  <div>
                    <span className="font-semibold">极强算力：</span>
                    <span>Overall TOPS最高可达 126 TOPS，NPU TOPS最高可达 50 TOPS</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 产品优势 */}
      <section className="snap-section py-20">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-white text-center mb-16">产品优势</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8 hover:bg-opacity-20 transition-all duration-300">
              <div className="text-4xl mb-4">🔒</div>
              <h3 className="text-2xl font-bold text-white mb-4">数据安全</h3>
              <p className="text-blue-200">
                数据本地化处理，无泄露风险，企业核心信息完全掌控在自己手中
              </p>
            </div>
            
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8 hover:bg-opacity-20 transition-all duration-300">
              <div className="text-4xl mb-4">💰</div>
              <h3 className="text-2xl font-bold text-white mb-4">成本节约</h3>
              <p className="text-blue-200">
                本地消化算力，无需在外调算力消耗，免去大量的TOKEN费用，长期使用更经济
              </p>
            </div>
            
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8 hover:bg-opacity-20 transition-all duration-300">
              <div className="text-4xl mb-4">⚡</div>
              <h3 className="text-2xl font-bold text-white mb-4">高效响应</h3>
              <p className="text-blue-200">
                本地部署，低延迟响应，每秒40TOKEN的处理速度，带来流畅的AI交互体验
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 应用场景 */}
      <section className="snap-section py-20">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-white text-center mb-16">应用场景</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 hover:shadow-2xl transition-all duration-300">
              <h3 className="text-xl font-bold text-white mb-3">企业办公</h3>
              <p className="text-blue-200 text-sm">智能文档处理，会议纪要生成，办公自动化</p>
            </div>
            
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 hover:shadow-2xl transition-all duration-300">
              <h3 className="text-xl font-bold text-white mb-3">教育领域</h3>
              <p className="text-blue-200 text-sm">智能辅导，个性化学习，教育资源整合</p>
            </div>
            
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 hover:shadow-2xl transition-all duration-300">
              <h3 className="text-xl font-bold text-white mb-3">科研开发</h3>
              <p className="text-blue-200 text-sm">数据处理，模型训练，科研辅助</p>
            </div>
            
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 hover:shadow-2xl transition-all duration-300">
              <h3 className="text-xl font-bold text-white mb-3">个人创作</h3>
              <p className="text-blue-200 text-sm">内容创作，创意生成，个人助理</p>
            </div>
          </div>
        </div>
      </section>
      {/* 联系咨询 */}
      <section className="snap-section py-20">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-8">开启您的智能计算之旅</h2>
          <p className="text-xl text-blue-200 mb-12 max-w-3xl mx-auto">
            小型算力中心，为您的企业和个人提供强大的AI计算能力，安全、高效、经济
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-4">
            <a href="mailto:406117951@qq.com" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-300 text-lg">
              联系我们
            </a>
            <a href="/price" className="bg-transparent border-2 border-blue-400 text-blue-400 hover:bg-blue-400 hover:text-black font-bold py-3 px-8 rounded-lg transition-colors duration-300 text-lg">
              查看价格
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default PricePage;